/* Only controls the surrounding experience disclosures, never the booking app. */
if (!customElements.get('fr-booking-explore')) {
  customElements.define('fr-booking-explore', class extends HTMLElement {
    connectedCallback() {
      this.disclosure = this.querySelector('[data-experiences]');
      if (!this.disclosure) return;
      this.mobile = window.matchMedia('(max-width: 1049px)');
      this.setLayout = () => { this.disclosure.open = !this.mobile.matches; };
      this.setLayout();
      this.mobile.addEventListener('change', this.setLayout);
      this.selectBlock = (event) => {
        if (!this.contains(event.target)) return;
        this.disclosure.open = true;
        const item = event.target.closest('.fr-booking-explore__item');
        if (item) item.open = true;
      };
      this.addEventListener('shopify:block:select', this.selectBlock);
    }
    disconnectedCallback() {
      this.mobile?.removeEventListener('change', this.setLayout);
      this.removeEventListener('shopify:block:select', this.selectBlock);
    }
  });
}
